import PadraoModel from 'src/core/model/PadraoModel.js'

export default class MobiautoModeloModel extends PadraoModel {
  recurso = 'mobiauto/modelos';
  microServico = 'automotor';
  include = null;
  searchFixo = null;
  nome = 'Modelos Mobiauto';

  colunasGrid = [
  ];

  form = {
    id: null,
    name: null
  };

  constructor (marca) {
    super()
    this.formLimpo = Object.assign({}, this.form)
    if (marca) this.recurso += `/${marca}`
  }
}
